/* eslint-disable no-param-reassign */
/* eslint-disable arrow-body-style */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    latestPerYear: [],
    noResults: {
      sentenze: false,
      ordinanze: false,
    },
    documentsList: {
      sentenze: [],
      ordinanze: [],
      totalSentenze: 0,
      totalOrdinanze: 0,
    },
    presidenti: [],
    relatori: [],
    giudici: [],
    pronunceFilters: {
      years: [],
      numbers: [],
      ecli: [],
      presidents: [],
      relators: [],
      judges: [],
    },
  },
  getters: {
    LATEST_PER_YEAR: (state) => {
      return state.latestPerYear;
    },
    DOCUMENTS_LIST: (state) => {
      return state.documentsList;
    },
    PRESIDENTI: (state) => {
      return state.presidenti;
    },
    RELATORI: (state) => {
      return state.relatori;
    },
    GIUDICI: (state) => {
      return state.giudici;
    },
    FILTERS: (state) => {
      return state.pronunceFilters;
    },
  },
  mutations: {
    ADD_YEAR: (state, payload) => {
      state.latestPerYear.push(payload);
    },
    ADD_DOCUMENTS_SET: (state, payload) => {
      if (payload.type === 'sentenza') {
        state.documentsList.totalSentenze = payload.total;
        if (state.documentsList.totalSentenze > 0) {
          payload.docs.forEach((p) => {
            state.documentsList.sentenze.push(p);
          });
        } else {
          state.noResults.sentenze = true;
        }
      } else if (payload.type === 'ordinanza') {
        state.documentsList.totalOrdinanze = payload.total;
        if (state.documentsList.totalOrdinanze > 0) {
          payload.docs.forEach((p) => {
            state.documentsList.ordinanze.push(p);
          });
        } else {
          state.noResults.ordinanze = true;
        }
      }
    },
    DELETE_DOCUMENTS_SET: (state, payload) => {
      if (!payload) {
        state.noResults.sentenze = false;
        state.noResults.ordinanze = false;
        state.documentsList.sentenze = [];
        state.documentsList.ordinanze = [];
        state.documentsList.totalSentenze = 0;
        state.documentsList.totalOrdinanze = 0;
      }
    },
    ADD_PRESIDENTE_SET: (state, payload) => {
      state.presidenti = payload;
    },
    ADD_RELATORE_SET: (state, payload) => {
      state.relatori = payload;
    },
    ADD_GIUDICE_SET: (state, payload) => {
      state.giudici = payload;
    },
    ADD_PRONUNCE_FILTER: (state, payload) => {
      Object.entries(payload.filters).forEach((e) => {
        state.pronunceFilters[e[0]] = e[1];
      });
    },
    DELETE_PRONUNCE_FILTER: (state, payload) => {
      if (!payload) {
        state.pronunceFilters.years = [];
        state.pronunceFilters.numbers = [];
        state.pronunceFilters.ecli = [];
        state.pronunceFilters.presidents = [];
        state.pronunceFilters.relators = [];
        // state.pronunceFilters.judges = [];
      } else {
        state.pronunceFilters[payload.type].splice(payload.index, 1);
      }
    },
  },
  actions: {
    SAVE_YEAR: async (context, payload) => {
      const { data } = await Vue.axios.get(
        `${Vue.prototype.$proxy}getLatestPerYear.xq`, {
          params: {
            year: payload,
          },
        },
      );
      data.year = payload;
      context.commit('ADD_YEAR', data);
    },
    SAVE_DOCUMENTS_LIST: async (context, payload) => {
      const { data } = await Vue.axios.get(
        `${Vue.prototype.$proxy}getDocumentsList.xq`, {
          params: {
            start: payload.start,
            size: payload.size,
            type: payload.type,
            years: context.state.pronunceFilters.years.join(','),
            presidents: context.state.pronunceFilters.presidents.join(','),
            relators: context.state.pronunceFilters.relators.join(','),
            // judges: context.state.pronunceFilters.judges.join(','),
          },
        },
      );
      data.type = payload.type;
      context.commit('ADD_DOCUMENTS_SET', data);
    },
    EMPTY_DOCUMENTS_LIST: (context, payload) => {
      context.commit('DELETE_DOCUMENTS_SET', payload);
    },
    SAVE_PEOPLE_LIST: async (context, payload) => {
      const { data } = await Vue.axios.get(
        `${Vue.prototype.$proxy}allPeople.xq`, {
          params: {
            role: payload.role,
          },
        },
      );
      if (payload.role === 'presidente') {
        context.commit('ADD_PRESIDENTE_SET', data);
      } else if (payload.role === 'relatore') {
        context.commit('ADD_RELATORE_SET', data);
      } else if (payload.role === 'giudice') {
        context.commit('ADD_GIUDICE_SET', data);
      }
    },
    SAVE_PRONUNCE_FILTER: (context, payload) => {
      context.commit('ADD_PRONUNCE_FILTER', payload);
    },
    EMPTY_PRONUNCE_FILTER: (context, payload) => {
      context.commit('DELETE_PRONUNCE_FILTER', payload);
    },
  },
});




// WEBPACK FOOTER //
// ./src/store/index.js